<p-toast position="top-center"></p-toast>
<div class="grid mt-4">
    <div class="col">
        <h2>Search Results</h2>
    </div>
</div>
<p-table #table stripedRows showGridlines [tableStyle]="{'min-width': '60rem'}" [value]="users"
     [paginator]="true" [rows]="100" [showCurrentPageReport]="true"
        [totalRecords]="searchResults.totalCount"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        styleClass="p-datatable-striped p-datatable-gridlines" responsiveLayout="scroll" role="table" [(first)]="first"
        (onSort)="onSort($event)" [scrollable]="true" scrollHeight="500px" [lazy]="true" (onPage)="onPageChange($event)"
        paginatorDropdownAppendTo="body" [sortOrder]="1">

        <ng-template pTemplate="caption"> 
            <div class="flex align-items-center justify-content-between" *ngIf="isAirmenAgentSearch">
                Airman / Operator List
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="!isAirmenAgentSearch && searchType !== 'externalUser'">
                Aircraft Registered Owner List 
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="!isAirmenAgentSearch && searchType === 'externalUser'">
                Users List 
            </div>
        </ng-template>
        <ng-template pTemplate="header" class="bg-blue-700">
            <tr class="devkit-table-row bg-blue-700">
                <th id="headers" *ngFor="let col of columns" style="width: 300px"
                [pSortableColumn]="col.isSortable ? col.field : null">
                <div class="flex align-items-center">
                    <ng-container *ngIf="col.isSortable">
                        <span>{{col.displayName}}</span>
                        <p-sortIcon *ngIf="col.isSortable" [field]="col.field" tabindex="0" [attr.aria-label]="'Sort by' + col.displayName"/>
                    </ng-container>
                </div>
                <div *ngIf="!col.isSortable">
                    <span>{{col.displayName}}</span>
                </div>
            </th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr class="devkit-table-row" role="row">
                <td *ngFor="let col of columns">{{user[col.field]}}</td>
                
                <td><a rel="noopener noreferrer" class="pl-0 p-button p-button-link" (click)="editOperator(user)" *ngIf="this.searchType !== 'externalUser'"><span class="pi pi-user-edit mr-1"></span>Edit</a>
                    <a rel="noopener noreferrer" class="pl-0 p-button p-button-link" (click)="deleteUser(user)" *ngIf="this.searchType === 'externalUser'"><span class="fas fa-trash-alt mr-1"></span>Delete</a>
                    <a rel="noopener noreferrer" class="pl-0 p-button p-button-link" (click)="activateUserEmail(user)" *ngIf="this.searchType === 'externalUser' && user['emailActivated'] === 'N'"><span class="fas fa-power-off mr-1"></span>Activate</a>
                </td>
            </tr>
        </ng-template>
    </p-table>